import { lazy, Suspense } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { usePatientDetails } from '../../contexts/PatientDetailsContext';

// The patient record (with the prescription wizard, rich-text editor and lab charts) loads only when a window is first
// opened. This component sits in the main Layout on every page, so a static import put all of that in the entry
// chunk and pushed it past the 2 MiB PWA precache limit (vite.config.ts).
const PatientProfile = lazy(() => import('./PatientProfile').then((m) => ({ default: m.PatientProfile })));

export function GlobalPatientWindows() {
  const { openPatients, closePatient } = usePatientDetails();
  const visible = Array.from(openPatients.entries()).filter(([, entry]) => !entry.isMinimized);
  if (visible.length === 0) return null;

  // Render all non-minimized open patient windows
  return (
    <Suspense fallback={<Backdrop open sx={{ zIndex: (t) => t.zIndex.modal + 1, color: '#fff' }}><CircularProgress color="inherit" /></Backdrop>}>
      {visible.map(([patientId, entry]) => (
        <PatientProfile
          key={patientId}
          patient={entry.patient}
          open={true}
          onClose={() => closePatient(patientId)}
          appointment={entry.appointment}
          initialSection={entry.initialSection}
        />
      ))}
    </Suspense>
  );
}
